const defaultLoginAuthorizationModule = escape('{"name": "authorization", "params": {}}');

const defaultResetAuthorizationModule = escape('{"name": "authorization", "params": {}}');

const defaultSignupAuthorizationModule = escape(
    '{"name": "authorization", "params": {"confirm_password": true}}'
);
const defaultPrivacyModule = escape(
    '{"name": "privacy_policy", "params": {"required": true, "text": "I have read and accept the privacy policy", "policy_url": "https://google.com/"}}'
);
const defaultSubmitModule = escape('{"name": "submit", "params": {}}');
const defaultUserInfoModule = escape('{"name": "user_info", "params": {"required": true}}');
const defaultFeedbackModule = escape('{"name": "feedback", "params": {}}');
const defaultGoToLoginModule = escape(
    '{"name": "goto", "params": {"to": ".login-form", "caption": "log in here"}}'
);
const defaultGoToSignupModule = escape(
    '{"name": "goto", "params": {"to": ".signup-form", "caption": "sign up here"}}'
);
const defaultGoToResetModule = escape(
    '{"name": "goto", "params": {"to": ".reset-form", "caption": "Forgot your password?"}}'
);
const defaultOtpModule = escape(
    '{"name": "otp_form", "params": {}}'
)

export const getDefaultLoginTemplate = ({
    authorizationModule = defaultLoginAuthorizationModule,
    submitModule = defaultSubmitModule,
    feedbackModule = defaultFeedbackModule,
    gotoSignup = defaultGoToSignupModule,
    gotoReset = defaultGoToResetModule,
} = {}) => `
<div class="authentication--headline">Login</div>
<div class="login-module" data-module="${feedbackModule}">
</div>
<div class="login-module" data-module="${authorizationModule}">
</div>
<div class="login-module" data-module="${submitModule}">
</div>
<div class="authentication--message">
    <div class="login-module" data-module="${gotoReset}"></div>
</div>
<div class="authentication--message">if you don't have an account
    <div class="login-module" data-module="${gotoSignup}"></div>
</div>
`;

export const getDefaultSignupTemplate = ({
    userInfoModule = defaultUserInfoModule,
    authorizationModule = defaultSignupAuthorizationModule,
    privacyModule = defaultPrivacyModule,
    submitModule = defaultSubmitModule,
    feedbackModule = defaultFeedbackModule,
    gotoLogin = defaultGoToLoginModule,
} = {}) => `
<div class="authentication--headline">Sign Up</div>
<div class="signup-module" data-module="${feedbackModule}">
</div>
<div class="signup-module" data-module="${userInfoModule}">
</div>
<div class="signup-module" data-module="${authorizationModule}">
</div>
<div class="signup-module" data-module="${privacyModule}">
</div>
<div class="signup-module" data-module="${submitModule}">
</div>
<div class="authentication--message">
    If you already have an account, <div class="signup-module" data-module="${gotoLogin}"></div>
</div>
`;

export const getDefaultResetTemplate = ({
    authorizationModule = defaultResetAuthorizationModule,
    submitModule = defaultSubmitModule,
    feedbackModule = defaultFeedbackModule,
    gotoSignup = defaultGoToSignupModule,
} = {}) => `
<div class="authentication--headline">Reset Password</div>
<div class="reset-module" data-module="${feedbackModule}">
</div>
<div class="reset-module" data-module="${authorizationModule}">
</div>
<div class="reset-module" data-module="${submitModule}">
</div>
<div class="authentication--message">if you don't have an account
    <div class="reset-module" data-module="${gotoSignup}"></div>
</div>
`;

export const getSuccessMessageTemplate = ({
    message,
}) => `<span class="authentication--success-message">
    ${message}
</span>`;

export const getFeedbackTemplate = () => `<span class="authentication--error-feedback"></span>
<span class="authentication--success-feedback"></span>`;

function renderAnchor({ className, target, rel, href = "", children = "" } = {}) {
    return `<a href="${href}"
    ${rel ? `rel="${rel}"` : ""}
    ${target ? `target="${target}"` : ""}
    ${className ? `class="${className}"` : ""}>
    ${children}
</a>`;
}

export const getGotoTemplate = ({ caption }) =>
    renderAnchor({ className: "authentication--goto", href: "javascript:;", children: caption });

export const getSubmitTemplate = ({ caption }) => `
    <button type="submit" class="authentication--submit">${caption}</button>
`;


export const getDefaultOtpTemplate = ({
    otpInput = defaultOtpModule, 
    feedbackModule = defaultFeedbackModule,
} = {}) => `
    <div class="otp-module--headline">OTP: </div>
    <div class="otp-module" data-module="${feedbackModule}"></div>
    <div class="otp-module" data-module="${otpInput}"></div>
` 

export const getSubmitOtpTemplate = ({ caption }) => `
    <button type="submit" class="otp--submit">${caption}</button>
`;

export const getFeedbackOtpTemplate = () => `<span class="otp--error-feedback">Invalid code!</span>
<span class="otp--success-feedback ">Valid code</span>`;

function getOption(option) {
    if (typeof option === "string" || myVar instanceof String)
        option = { caption: option, value: option };

    const { caption, value } = option;
    return `<option value="${value}">${caption}</option>`;
}

const getOptions = (options = []) => options.map(getOption).join("");

function getSelectField({ name, value, options, required = false }) {
    return `<select class="authentication--select"
        name="${name}"
        ${value ? `value="${value}"` : ""}
        ${required ? 'required="true"' : ""}
    >
    ${getOptions(options)}
    </select>`;
}

function getInputField({ type, ...props }) {
    if (type === "select") return getSelectField(props);

    const { name, placeholder, value, required = false, checked = false } = props;

    return `<input class="authentication--input"
        type="${type}"
        name="${name}"
        ${placeholder ? `placeholder="${placeholder}"` : ""}
        ${value ? `value="${value}"` : ""}
        ${required ? 'required="true"' : ""}
        ${checked ? 'checked="true"' : ""}
    />`;
}

export const getLabeledInputField = ({
    type,
    name,
    label,
    required,
} = {}) => `<label class="authentication--label authentication--field-${name}">
    <span class="authentication--label-caption">${label}</span>
    ${getInputField({ type, name, required, placeholder: label })}
</label>`;

export const getPrivacyPolicyTemplate = ({ text, policy_url, required }) => `
<label class="authentication--label">
    ${getInputField({ name: "privacy_policy", type: "checkbox", required: required })}
    <span class="authentication--label-caption">${text}</span>
    ${
        policy_url
            ? renderAnchor({
                  href: policy_url,
                  target: "_blank",
                  rel: "noreferrer noopener",
                  className: "authentication--label-anchor",
                  children: "more info",
              })
            : ""
    }
</label>`;

export function getExtraFieldTemplate({ required, field_name, ...props }) {
    const schema = props[field_name];

    let inputFieldProps = {
        name: field_name,
        required: required,
        default: schema.default,
    };

    switch (schema.type) {
        case "boolean":
            inputFieldProps.type = "checkbox";
            inputFieldProps.checked = schema.default;
            break;
        case "array":
            inputFieldProps.type = "select";
            inputFieldProps.value = schema.default;
            inputFieldProps.options = schema.items.enum;
            break;
        case "string":
        default:
            inputFieldProps.type = "enum" in schema ? "select" : "text";
            inputFieldProps.options = schema.enum;
            inputFieldProps.placeholder = schema.description;
            inputFieldProps.value = schema.default;
    }

    return `<label class="authentication--label authentication--field-${field_name}">
    <span class="authentication--label-caption">${schema.description}</span>
    ${getInputField(inputFieldProps)}
</label>`;
}
